.wishlistModal {
  > .content {
    overflow: visible;

    @media (min-width: 769px) {
      max-width: 31rem;
    }
  }

  .emojiModal {
    @media (min-width: 769px) {
      left: unset;
      right: 0;
    }
  }

  .name,
  .privacy {
    &:not(:last-child) {
      margin: 0 0 1.25rem;
    }
  }

  .row {
    display: flex;
    width: 100%;
    gap: 0.875rem;
  }

  .emoji {
    position: relative;
    flex: 0 0 auto;
    width: 2.875rem;
    height: 2.875rem;

    @media (min-width: 769px) {
      width: 2.625rem;
      height: 2.625rem;
    }

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .privacy {
  }

  .delete {
  }
}
